import './SalesforceSetupPanel.scss';
import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { createAsyncSelectors } from '@lib/selectors';
import dayjs from 'dayjs';
import { importsActions } from '@sonar-software/sonar-imports';
import { PlayCircleOutlined } from '@ant-design/icons';
import { useAction } from '@hooks';
import { Button, Checkbox, Popconfirm, Tag } from 'antd';
import React, { useCallback, useState } from 'react';
export const defaultShardCatalogDetailSelectors = createAsyncSelectors((state) => state.imports.salesforce.start.post);
export const SalesforceOrganizationSyncControls = (props) => {
    var _a;
    const { organization, shardName } = props;
    const [isSyncing, setIsSyncing] = useState((_a = organization === null || organization === void 0 ? void 0 : organization.salesforceSyncInProgress) !== null && _a !== void 0 ? _a : false);
    const [forceFullRefresh, setForceFullReset] = useState(false);
    const handleForceFullResetChange = useCallback((e) => {
        setForceFullReset(e.target.checked);
    }, []);
    const startSync = useAction(importsActions.requestPostImportsSalesforceStart);
    const handleStartSync = useCallback(() => {
        if (organization) {
            setIsSyncing(true);
            startSync({
                forceFullRefresh: forceFullRefresh,
                organizationId: organization.id,
                shardName: shardName
            });
        }
    }, [startSync, forceFullRefresh, organization, shardName]);
    const syncTime = (organization === null || organization === void 0 ? void 0 : organization.latestIndexTime) ? dayjs.utc(organization === null || organization === void 0 ? void 0 : organization.latestIndexTime).local()
        .calendar() : '';
    return organization ?
        React.createElement("div", null,
            React.createElement("span", { className: 'last-sync-status' },
                React.createElement("span", { className: 'last-sync-time' }, syncTime),
                React.createElement("span", { className: 'last-sync-failed' }, (organization === null || organization === void 0 ? void 0 : organization.salesforceSyncFailed) &&
                    React.createElement(Tag, { className: 'last-sync-failed-tag', color: 'red' }, ADMIN_DASHBOARD_COPY.FAILED))),
            isSyncing ?
                React.createElement(Button, { className: 'start-sync-button', loading: true }, ADMIN_DASHBOARD_COPY.SYNC_IN_PROGRESS) :
                React.createElement(Popconfirm, { cancelText: ADMIN_DASHBOARD_COPY.NO, className: 'start-sync-button', okText: ADMIN_DASHBOARD_COPY.YES, onConfirm: handleStartSync, title: ADMIN_DASHBOARD_COPY.START_NEW_SYNC_CONFIRMATION },
                    React.createElement(Button, { icon: React.createElement(PlayCircleOutlined, null) }, ADMIN_DASHBOARD_COPY.START_NEW_SYNC)),
            React.createElement(Checkbox, { checked: forceFullRefresh, className: 'force-full-refresh-checkbox', disabled: isSyncing, id: 'force-full-refresh-checkbox', onChange: handleForceFullResetChange }, ADMIN_DASHBOARD_COPY.FORCE_FULL_REFRESH)) :
        null;
};
